__turbopack_context__.v({
  "buttonShow": "TeamGrid-module__pcmlCG__buttonShow",
  "gridTeam": "TeamGrid-module__pcmlCG__gridTeam",
  "gridTeam__item": "TeamGrid-module__pcmlCG__gridTeam__item",
  "gridTeam__item__figure": "TeamGrid-module__pcmlCG__gridTeam__item__figure",
  "gridTeam__item__foot": "TeamGrid-module__pcmlCG__gridTeam__item__foot",
  "gridTeams": "TeamGrid-module__pcmlCG__gridTeams",
});
